import { Card, Col, Empty, Row, Table, Select } from "antd";
import { useSelector } from "react-redux";
import { UNITS } from "../../../Common/Constants";
import RIGHT_TURN from "../../../../assets/images/icons/rightTurn.svg";
import LEFT_TURN from "../../../../assets/images/icons/leftTurn.svg";
import { TEST_RIDE_SUMMARY } from "../../../Common/Grafana/Constants";
import GetIframe from "../../../Common/Grafana/GetIframe";
import { useMemo, useState } from "react";
import panelList from "./panelList.json";
import { isEmpty } from "lodash";

const SpeedMap = ({ baseUrl, baseFilterObject }) => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [geo, setGeo] = useState(panelList?.geo?.[0]?.var_name);

  useMemo(() => {
    setGeo(panelList?.geo?.[0]?.var_name);

    // eslint-disable-next-line
  }, [tripSummary]);

  const columns = [
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: "40%",
      render: (_, record, dataIndex) => {
        return (
          <div className="left w100">
            <div className="align-center w100">
              <div className={"mode" + dataIndex} />
              <div className="mode-text">{record.mode}</div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Frequent Speed",
      dataIndex: "speed",
      key: "speed",
      render: (_, record) => {
        return `${record.speed} ${UNITS.KM_PER_HR}`;
      },
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      render: (_, record) => {
        return `${record.distance} ${UNITS.KM}`;
      },
    },
  ];

  const overallImageText = () => {
    return (
      <div className="flex-center">
        <div className="mr05 mode-overall" /> OVERALL
      </div>
    );
  };

  const onSelectGeo = (selectedValues) => {
    setGeo(selectedValues);
  };

  const driveModeVariable = () => {
    const modeList = TEST_RIDE_SUMMARY?.DRIVE_MODE_VARIABLES?.map(
      (mode, index) => ({
        [mode]: tripSummary?.tripModeStats?.[index]?.mode || "",
      })
    );
    return Object.assign(baseFilterObject, ...modeList);
  };

  return (
    <Row gutter={[16, 16]} className="mt1">
      <Col xs={24} sm={24} md={24} lg={10} xl={10}>
        <Row>
          <Col span={24}>
            <Card
              title="Driving Modes"
              className="drive-mode-card"
              actions={
                tripSummary?.tripOverallModeStats &&
                !isEmpty(tripSummary?.tripOverallModeStats) && [
                  overallImageText(),
                  `${parseFloat(
                    tripSummary?.tripOverallModeStats?.speed
                  ).toFixed(2)} ${UNITS.KM_PER_HR}`,
                  `${parseFloat(
                    tripSummary?.tripOverallModeStats?.distance
                  ).toFixed(2)} ${UNITS.KM}`,
                ]
              }
            >
              {tripSummary?.tripModeStats?.length > 0 ? (
                <Table
                  className="mode-table"
                  rowKey={(record) => record.mode}
                  columns={columns}
                  dataSource={tripSummary?.tripModeStats}
                  pagination={false}
                  scroll={{ x: "100%", y: 140 }}
                />
              ) : (
                <div className="pd2015">
                  <Empty />
                </div>
              )}
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="mt05">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Card
              title={
                <div className="overview-header">
                  <img src={RIGHT_TURN} alt="km" className="icon20 mr05" />
                  Right Turn
                </div>
              }
            >
              <div className="mtb1025 text-center">
                <span className="avg-count">{tripSummary?.rightTurns}</span>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Card
              title={
                <div className="overview-header">
                  <img src={LEFT_TURN} alt="km" className="icon20 mr05" />
                  Left Turn
                </div>
              }
            >
              <div className="mtb1025 text-center">
                <span className="avg-count">{tripSummary?.leftTurns}</span>
              </div>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={24} md={24} lg={14} xl={14}>
        <Card
          classNames={{ body: "p0" }}
          title={
            <Row justify={"space-between"}>
              <Col className="flex-center">Route</Col>
              <Col className="font-weight-normal">
                <Select
                  value={geo || panelList?.geo?.[0]?.var_name}
                  style={{ width: "200px" }}
                  onChange={onSelectGeo}
                  data-testid="route-map-dropdown"
                  options={panelList?.geo?.map((i) => ({
                    label: i.title,
                    value: i.var_name,
                  }))}
                />
              </Col>
            </Row>
          }
        >
          <Col span={24} id="geo">
            <GetIframe
              title="Geo"
              url={baseUrl}
              panelId={TEST_RIDE_SUMMARY.PANEL_ID?.geo?.[geo]}
              variableObject={
                geo === "locDriveMode" ? driveModeVariable() : baseFilterObject
              }
              variableKeys={
                geo === "locDriveMode"
                  ? [
                      ...TEST_RIDE_SUMMARY?.BASE_VARIABLES,
                      ...TEST_RIDE_SUMMARY?.DRIVE_MODE_VARIABLES,
                    ]
                  : TEST_RIDE_SUMMARY.BASE_VARIABLES
              }
              width="100%"
              height="352"
              divId="geo"
            />
          </Col>
        </Card>
      </Col>
    </Row>
  );
};

export default SpeedMap;
